export enum InsightDataType {
  WATER_LEVEL = 'water_level',
  TEMPERATURE = 'temp',
  EVENTS = 'events_graph',
}
